import { db } from "../db";

export const ExportIndexedb = async () => {
  const expenses = await db.expenses.toArray();
  const categories = await db.categories.toArray();

  // Get username and currency from localStorage
  const userName = localStorage.getItem("username");
  const currency = localStorage.getItem("selectedCurrency");

  const data = {
    expenses,
    categories,
    profile: {
      userName,
      currency: JSON.parse(currency),
    },
  };

  const blob = new Blob([JSON.stringify(data)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "ExpenseApp-Data.json";
  a.click();
  URL.revokeObjectURL(url);
};

export const ImportIndexedb = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = async (e) => {
    const data = JSON.parse(e.target.result);

    await db.transaction("rw", db.expenses, db.categories, async () => {
      // Clear existing data
      await db.expenses.clear();
      await db.categories.clear();

      // Add new data
      await db.expenses.bulkAdd(data.expenses);
      await db.categories.bulkAdd(data.categories);
    });

    // Set profile data (username and currency) in localStorage
    if (data.profile) {
      localStorage.setItem("username", data.profile.userName);
      localStorage.setItem(
        "selectedCurrency",
        JSON.stringify(data.profile.currency)
      );
    }

    alert("Database imported successfully!");
  };
  reader.readAsText(file);
};

